import { collection, findSelector, resource } from "data/helpers/apiv3";
import { Photo } from "data/records";

const [api, actions] = resource(Photo, [["create", collection.post("", ["parentId", "parentType", "file"])]]);

const selectors = {
  ...findSelector(Photo),
};

const reducers = {};

const initialState = {};

export {
  api as photoApi,
  actions as photoActions,
  selectors as photoSelectors,
  reducers as photoReducers,
  initialState as photoInitialState,
};
